import React from 'react';
import { Bed, Bath, Car, Square, Ruler, Home as HomeIcon } from 'lucide-react';
import { HomeSpecs } from '../types';

interface SpecsTableProps {
  specs: HomeSpecs;
}

const SpecsTable: React.FC<SpecsTableProps> = ({ specs }) => {
  const specItems = [
    {
      icon: Bed,
      label: 'Bedrooms',
      value: specs.bedrooms.toString()
    },
    {
      icon: Bath,
      label: 'Bathrooms',
      value: specs.bathrooms.toString()
    },
    ...(specs.garage ? [{
      icon: Car,
      label: 'Garage',
      value: specs.garage.toString()
    }] : []),
    {
      icon: Square,
      label: 'Total Area',
      value: `${specs.totalArea}m²`
    },
    ...(specs.minLotWidth ? [{
      icon: Ruler,
      label: 'Min Lot Width',
      value: `${specs.minLotWidth}m`
    }] : [])
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <h3 className="text-xl font-bold text-[#1F2937] mb-6 flex items-center space-x-2">
        <HomeIcon className="w-6 h-6 text-[#FF5A1F]" />
        <span>Specifications</span>
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {specItems.map((item, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 bg-[#F3F4F6] rounded-lg">
            <div className="flex-shrink-0 w-10 h-10 bg-[#FF5A1F]/10 rounded-lg flex items-center justify-center">
              <item.icon className="w-5 h-5 text-[#FF5A1F]" />
            </div>
            <div>
              <div className="text-sm text-[#334155] font-medium">{item.label}</div>
              <div className="text-lg font-bold text-[#1F2937]">{item.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Living Areas */}
      {specs.livingAreas && specs.livingAreas.length > 0 && (
        <div className="mt-6">
          <h4 className="text-lg font-semibold text-[#1F2937] mb-3">Living Areas</h4>
          <div className="flex flex-wrap gap-2">
            {specs.livingAreas.map((area, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-[#FF5A1F]/10 text-[#FF5A1F] rounded-full text-sm font-medium"
              >
                {area}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Outdoor Spaces */}
      {specs.outdoorSpaces && specs.outdoorSpaces.length > 0 && (
        <div className="mt-6">
          <h4 className="text-lg font-semibold text-[#1F2937] mb-3">Outdoor Spaces</h4>
          <div className="flex flex-wrap gap-2">
            {specs.outdoorSpaces.map((space, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium"
              >
                {space}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecsTable;